
import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class InsaatTuruAPI extends BaseAPI {


  constructor() {
    const baseUrl = environment.API_URL + "InsaatTuruListe";
    super(baseUrl);
  }


  getInsaatTuruListe(insaatTuruKodu?: number) {
    return this.get("", { params: { insaatTuruKodu: insaatTuruKodu } })

  }

}
export default new InsaatTuruAPI();

